import * as React from "react";
import { Progress as BaseProgress } from "@base-ui/react/progress";
import { cn } from "@/lib/utils";

interface ProgressProps extends React.HTMLAttributes<HTMLDivElement> {
  value?: number;
}

const Progress = React.forwardRef<HTMLDivElement, ProgressProps>(
  ({ className, value = 0, ...props }, ref) => {
    const clampedValue = Math.max(0, Math.min(100, value));

    return (
      <BaseProgress.Root ref={ref} value={clampedValue} {...props}>
        <BaseProgress.Track
          className={cn(
            "w-full h-1.5 rounded-full overflow-hidden bg-[hsl(var(--muted))]",
            className,
          )}
        >
          <BaseProgress.Indicator
            className="h-full rounded-full bg-[var(--accent-raw)] transition-[width] duration-400 ease-[cubic-bezier(0.4,0,0.2,1)]"
            style={{ width: `${clampedValue}%` }}
          />
        </BaseProgress.Track>
      </BaseProgress.Root>
    );
  },
);
Progress.displayName = "Progress";

export { Progress };
